<template>
  <div class="betexy-container">
    <div class="stats-box">
      <div class="top_block">
        <img src="../../assets/logo.svg" alt="logo">
        <h1 class="title">Приветствуем вас!</h1>
        <p class="subtitle">
          Betexy представляет сервис для валуйных ставок<br>
          с математическим преимуществом над букмекером и предлагает<br>
          вам стать частью нашего сообщества
        </p>
      </div>


      <div class="stats-container">
        <div class="stats-content">
          <h2 class="stats-title">Статистика Betexy за 4 года</h2>
          <div class="stat_items">
            <div class="stats">
              <div class="stat"><span class="label purple">Ставок</span> <span class="value">30 367 116</span></div>
              <div class="stat"><span class="label blue">Оборот</span> <span class="value">152 956 085 €</span></div>
              <div class="stat"><span class="label green">Прибыль</span> <span class="value">7 969 012 €</span></div>
              <div class="stat"><span class="label orange">ROI</span> <span class="value">5.21 %</span></div>
            </div>
            <img src="../../assets/chart.svg" alt="Chart" class="chart" />
          </div>
        </div>
      </div>
      <p class="footer-text">
          Уже тысячи игроков зарабатывают с нами, присоединяйтесь и вы!
        </p>
    </div>

    <!-- === Правая часть (Форма) === -->
    <div class="form-box">
      <img src="../../assets/logo.svg" class="logo" alt="Logo" />

      <form autocomplete="off" @submit.prevent="login" novalidate>
        <b-loading :is-full-page="false" v-model="formLoading" :can-cancel="false" />

        <b-field label="Email" label-position="on-border"
                 :message="'email' in errors ? errors['email'] : ''"
                 :type="'email' in errors ? 'is-danger' : ''">
          <b-input type="text" v-model="form.email" icon="email" autocomplete="off" />
        </b-field>

        <b-field label="Пароль" label-position="on-border"
                 :message="'password' in errors ? errors['password'] : ''"
                 :type="'password' in errors ? 'is-danger' : ''">
          <b-input type="password" v-model="form.password" icon="lock" autocomplete="off" />
        </b-field>

        <div v-show="usingRecaptcha" class="recaptcha">
          <vue-recaptcha ref="recaptcha" :sitekey="sitekey" @verify="onVerify" :loadRecaptchaScript="true" />
        </div>

        <b-button class="register-button" :disabled="!submitEnabled" native-type="submit">
          <span>Зарегистрироваться</span>
        </b-button>

        <router-link to="/login" class="login-link">Войти</router-link>
      </form>

      <div class="language-switcher">
        <a @click="$ml.change('ru')" title="Русский"><img src="../../assets/ru.png"/></a>
        <a @click="$ml.change('en')" title="English"><img src="../../assets/en.png" /></a>
      </div>
    </div>
  </div>
</template>


<script>
import VueRecaptcha from 'vue-recaptcha'
import router from "@/router"
import Vue from "vue"

export default {
  components: { VueRecaptcha },
  data() {
    return {
      form: {
        email: '',
        password: '',
        ref_code: ''
      },
      errors: {},
      formLoading: false,
      captcha: false,
      sitekey: process.env.VUE_APP_SITE_KEY,
      usingRecaptcha: !!process.env.VUE_APP_RECAPTCHA
    }
  },
  computed: {
    submitEnabled() {
      return this.form.email.length >= 5 && this.form.password.length >= 6 && this.captcha
    }
  },
  methods: {
    onVerify(response) {
      if (response) this.captcha = true
    },
    login() {
      this.formLoading = true
      Vue.prototype.$http.post(`${process.env.VUE_APP_API_HOST}auth/signup`, { user: this.form })
        .then(() => router.push('/login?c=t'))
        .catch(error => {
          this.errors = error.response.data.result
        })
        .finally(() => this.formLoading = false)
    }
  },
  mounted() {
    const ref = this.$route.query.rc || localStorage.getItem('ref')
    if (ref) {
      localStorage.setItem('ref', ref)
      this.form.ref_code = ref
    }
  }
}
</script>

<style scoped>
.betexy-container {
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  padding: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.stats-box {
  flex: 1;
  max-width: 800px;
  text-align: center;
  background: linear-gradient(10deg, rgba(178, 132, 234, 1), rgba(255, 255, 255, 1));
  color: #1d1d1f;
  border-radius: 20px;
  padding: 40px 20px;
}

.title { font-size: 2rem; font-weight: bold; }
.subtitle { margin: 1rem 0; font-size: 1rem; }

.stats-container { padding: 30px; border-radius: 10px; }
.stats-content { background: white; border-radius: 16px; padding: 1.5rem; }
.stats-title { font-size: 1.2rem; margin-bottom: 1rem; font-weight: 600; }

.stat_items { display: flex; justify-content: space-between; gap: 10px;  }

@media (max-width: 1200px){
  .stat_items{
    display: grid;
    grid-column: 2;
  }
}
.stats { display: grid; grid-column: 1; }
.stat { margin: 0.3rem 0; font-size: 1rem; }
.value { font-weight: bold; font-size: 21px; }
.label { font-weight: bold; padding: 0.3rem 1.5rem; border-radius: 6px; color: white; }

.purple { background: rgba(154, 19, 179, 1); }
.blue   { background: rgba(27, 181, 254, 1); }
.green  { background: rgba(47, 204, 113, 1); }
.orange { background: rgba(249, 191, 59, 1); }

.chart { width: 100%; margin-top: 1rem; }
.footer-text { margin-top: 2rem; font-size: 0.95rem; color: white; font-weight: 600; }

/* Форма */
.form-box {
  flex: 1;
  max-width: 400px;
  background: white;
  border-radius: 16px;
  padding: 2rem;
}

.logo { max-width: 200px; display: block; margin: 0 auto 1.5rem; }

.register-button {
  background-color: rgba(109, 82, 183, 1);
  color: white !important;
  width: 100%;
  margin-top: 1rem;
  font-size: 1.1rem;
  padding: 0.9rem;
}

.login-link {
  display: block;
  margin-top: 1rem;
  text-align: center;
  color: rgba(109, 82, 183, 1);
  font-weight: 600;
}

.language-switcher {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  gap: 12px;
}

/* === Desktop (>=1200px) === */
@media (min-width: 1200px) {
  .language-switcher {
    position: fixed;
    right: 20px;
    bottom: 20px;
    margin-top: 0;
    justify-content: flex-end;
  }
}

.language-switcher img { width: 40px; height: 40px; cursor: pointer; }

/* === Tablet (768px - 1199px) === */
@media (max-width: 1199px) and (min-width: 769px) {
  .betexy-container { flex-direction: row; padding: 2rem; gap: 20px; }
  .stats-box, .form-box { flex: 1 1 45%; max-width: 100%; }
}

@media (max-width: 768px){
  .top_block{
    background: rgba(236, 241, 250, 1);
    padding: 20px 16px;
    margin: 0 auto;
    border-radius: 12px;
    margin-top: -20px;
  }

  .stats-box{
    padding: 0;
  }

  .footer-text{
    padding: 25px 10px;
    margin-top: 0px;
    border-radius: 0 0 20px 20px;

  }
}

@media (min-width: 768px){
  .top_block img{
    display: none;
  }
}

/* === Mobile (<=768px) === */
@media (max-width: 768px) {
  .betexy-container { flex-direction: column-reverse; padding: 0; }

  .form-box {
    order: 1;
    border-radius: 0;
    padding: 1.5rem 1rem;
    max-width: 100%;
  }

  .logo { max-width: 150px; margin-bottom: 1rem; }

  .register-button { font-size: 1rem; padding: 0.8rem; }

  .login-link { font-size: 0.95rem; margin-top: 0.8rem; }

  .language-switcher { margin-top: 1.5rem; }

  .language-switcher img { width: 32px; height: 32px; }

  .stats-box {
    background: var(--bg-color);
    order: 2;
    border-radius: 0;
    max-width: 100%;

  }

  .stats-content { padding: 1rem; }
  .value { font-size: 18px; }
}
</style>